const RAW_EGYPT_CITIES: Record<string, string> = {
  cairo:
    'مدينة نصر، مصر الجديدة، النزهة، القاهرة الجديدة، التجمع الخامس، الرحاب، مدينتي، الشروق، بدر، المعادي، حلوان، 15 مايو، التبين، المعصرة، طره، دار السلام، البساتين، مصر القديمة، المقطم، الخليفة، السيدة زينب، عابدين، قصر النيل، الأزبكية، بولاق، الموسكي، باب الشعرية، الظاهر، الوايلي، شبرا، روض الفرج، الساحل، الشرابية، الزاوية الحمراء، حدائق القبة، الزيتون، المطرية، عين شمس، المرج، السلام',
  giza:
    'الجيزة، الدقي، العجوزة، المهندسين، الهرم، فيصل، العمرانية، بولاق الدكرور، إمبابة، الوراق، المنيب، حدائق الأهرام، 6 أكتوبر، الشيخ زايد، كرداسة، أوسيم، الحوامدية، البدرشين، العياط، الصف، أطفيح، أبو النمرس، منشأة القناطر، الواحات البحرية',
  alexandria:
    'المنتزه، المعمورة، أبو قير، العصافرة، المندرة، ميامي، سيدي بشر، فيكتوريا، سان ستيفانو، جليم، زيزينيا، رشدي، ستانلي، كليوباترا، سيدي جابر، سموحة، الإبراهيمية، محرم بك، باكوس، العطارين، المنشية، الجمرك، كرموز، اللبان، مينا البصل، القباري، الورديان، المكس، الدخيلة، العجمي، الهانوفيل، البيطاش، العامرية، برج العرب',
  qalyubia:
    'بنها، شبرا الخيمة، قليوب، القناطر الخيرية، الخانكة، الخصوص، العبور، كفر شكر، طوخ، شبين القناطر، قها',
  sharqia:
    'الزقازيق، العاشر من رمضان، بلبيس، منيا القمح، أبو حماد، أبو كبير، فاقوس، ههيا، ديرب نجم، الحسينية، كفر صقر، أولاد صقر، مشتول السوق، الإبراهيمية، القرين، القنايات، صان الحجر، منشأة أبو عمر، الصالحية الجديدة',
  dakahlia:
    'المنصورة، طلخا، ميت غمر، دكرنس، أجا، السنبلاوين، بلقاس، شربين، المنزلة، الجمالية، منية النصر، المطرية، بني عبيد، تمي الأمديد، محلة دمنة، نبروه، ميت سلسيل، الكردي، جمصة',
  beheira:
    'دمنهور، كفر الدوار، رشيد، إدكو، أبو المطامير، أبو حمص، الدلنجات، المحمودية، الرحمانية، إيتاي البارود، حوش عيسى، شبراخيت، كوم حمادة، بدر، وادي النطرون، النوبارية الجديدة',
  gharbia:
    'طنطا، المحلة الكبرى، كفر الزيات، زفتى، السنطة، قطور، بسيون، سمنود',
  monufia:
    'شبين الكوم، مدينة السادات، منوف، سرس الليان، أشمون، الباجور، قويسنا، بركة السبع، تلا، الشهداء',
  kafr_el_sheikh:
    'كفر الشيخ، دسوق، فوه، مطوبس، بلطيم، برج البرلس، الحامول، بيلا، الرياض، سيدي سالم، قلين، سيدي غازي',
  damietta:
    'دمياط، دمياط الجديدة، رأس البر، فارسكور، الزرقا، كفر سعد، كفر البطيخ، السرو، الروضة، عزبة البرج، ميت أبو غالب',
  port_said:
    'حي الشرق، حي العرب، حي المناخ، حي الزهور، حي الضواحي، حي الجنوب، حي الغرب، بورفؤاد',
  ismailia:
    'الإسماعيلية، فايد، القنطرة شرق، القنطرة غرب، التل الكبير، أبو صوير، القصاصين الجديدة',
  suez:
    'حي السويس، حي الأربعين، حي عتاقة، حي الجناين، حي فيصل',
  north_sinai:
    'العريش، الشيخ زويد، رفح، بئر العبد، الحسنة، نخل',
  south_sinai:
    'الطور، شرم الشيخ، دهب، نويبع، طابا، سانت كاترين، رأس سدر، أبو رديس، أبو زنيمة',
  beni_suef:
    'بني سويف، بني سويف الجديدة، الواسطى، ناصر، إهناسيا، ببا، الفشن، سمسطا',
  faiyum:
    'الفيوم، الفيوم الجديدة، طامية، سنورس، إطسا، إبشواي، يوسف الصديق',
  minya:
    'المنيا، المنيا الجديدة، العدوة، مغاغة، بني مزار، مطاي، سمالوط، أبو قرقاص، ملوي، دير مواس',
  asyut:
    'أسيوط، أسيوط الجديدة، ديروط، القوصية، منفلوط، أبنوب، الفتح، أبو تيج، الغنايم، صدفا، ساحل سليم، البداري',
  sohag:
    'سوهاج، سوهاج الجديدة، أخميم، ساقلتة، المراغة، طهطا، طما، جهينة، المنشأة، جرجا، البلينا، دار السلام، العسيرات',
  qena:
    'قنا، قنا الجديدة، أبو تشت، فرشوط، نجع حمادي، دشنا، الوقف، قفط، قوص، نقادة',
  luxor:
    'الأقصر، طيبة الجديدة، القرنة، أرمنت، إسنا، الطود، البياضية، الزينية',
  aswan:
    'أسوان، أسوان الجديدة، دراو، كوم أمبو، نصر النوبة، إدفو، كلابشة، أبو سمبل',
  red_sea:
    'الغردقة، رأس غارب، سفاجا، القصير، مرسى علم، الشلاتين، حلايب',
  new_valley:
    'الخارجة، الداخلة، الفرافرة، باريس، بلاط',
  matrouh:
    'مرسى مطروح، الحمام، العلمين، الضبعة، النجيلة، سيدي براني، السلوم، سيوة',
};

export const EGYPT_CITIES: Record<string, string[]> = Object.fromEntries(
  Object.entries(RAW_EGYPT_CITIES).map(([gov, list]) => [
    gov,
    list
      .split('،')
      .map((city) => city.trim())
      .filter(Boolean),
  ])
);
